module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer003"
    }
  }, [_c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer000"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/icons_for_book.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("All Is ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Calm")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("A Maine Christmas ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Reader ")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame _idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer001"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Edited by")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v(" Shannon Butler")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/ISLANDPRT_Horiz_BLKlogo.png"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75d42d88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/All_is_calm_interior_epub.vue
// module id = 57
// module chunks = 0